/*  Search and cart panels for the Echo Valley top bar.

    PROGRESSIVE ENHANCEMENT ON PURPOSE. The icons are real links to /search and /cart
    and stay that way in the markup. This only intercepts the click when it can
    actually do better. If the script fails to load, or the fetch dies, the link still
    works and the visitor still reaches the page. A cart you cannot open because a
    script 404'd would be a real lost sale.  */
(function () {
  'use strict';

  var bar = document.querySelector('.ev-topnav-bar');
  if (!bar) return;

  var panels = {
    search: bar.querySelector('#evPanelSearch'),
    cart:   bar.querySelector('#evPanelCart')
  };
  var open = null;

  function close () {
    if (!open) return;
    panels[open].classList.remove('is-open');
    open = null;
  }

  function show (which) {
    if (open === which) { close(); return; }
    close();
    open = which;
    panels[which].classList.add('is-open');
  }

  // ── money ───────────────────────────────────────────────────────────
  // TWO ENDPOINTS, TWO UNITS. This is the one thing to get right in this file.
  //   /cart.js               hands back INTEGER CENTS.  $40.00 arrives as 4000.
  //   /search/suggest.json   hands back a DOLLAR STRING. $40.00 arrives as "40.00".
  // There used to be a single formatter that divided by a hundred, correct for the cart
  // and wrong for search, which put a 25 cent price tag under a twenty five dollar kit.
  // The two are separate now and named after the unit they take, so calling the wrong
  // one reads as wrong at the call site instead of silently costing two decimal places.
  function wrap (amount) {
    var f = (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}';
    return f.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }
  function moneyFromCents (cents) {
    return wrap((cents / 100).toFixed(2));
  }
  function moneyFromDollars (s) {
    // Strip any symbol or separator the shop's locale might have put in the string.
    var n = parseFloat(String(s).replace(/[^0-9.\-]/g, ''));
    return isNaN(n) ? '' : wrap(n.toFixed(2));
  }

  function esc (s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── search ────────────────────────────────────────────────────────
  var input   = bar.querySelector('#evSearchInput');
  var results = bar.querySelector('#evSearchResults');
  var srchLbl = bar.querySelector('#evSearchLabel');
  var timer   = null;
  var lastQ   = '';

  function renderResults (products, q) {
    if (!products.length) {
      srchLbl.textContent = 'No matches for “' + q + '”';
      results.innerHTML = '';
      return;
    }
    srchLbl.textContent = 'Products';
    results.innerHTML = products.map(function (p) {
      var img = p.featured_image && p.featured_image.url
        ? '<img class="ev-srch-thumb" src="' + esc(p.featured_image.url) + '" alt="" loading="lazy">'
        : '<span class="ev-srch-thumb"></span>';
      var price = p.price != null
        ? '<span class="ev-srch-price">' + moneyFromDollars(p.price) + '</span>' : '';
      return '<li><a href="' + esc(p.url) + '">' + img +
             '<span>' + esc(p.title) + '</span>' + price + '</a></li>';
    }).join('');
  }

  function search (q) {
    if (q === lastQ) return;
    lastQ = q;

    if (q.length < 2) {
      srchLbl.textContent = 'Start typing';
      results.innerHTML = '';
      return;
    }

    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var p = (d.resources && d.resources.results && d.resources.results.products) || [];
        renderResults(p, q);
      })
      .catch(function () {
        // Never leave it looking broken: offer the real search page instead.
        srchLbl.textContent = 'Search';
        results.innerHTML = '<li><a href="/search?q=' + encodeURIComponent(q) +
                            '">See all results for “' + esc(q) + '”</a></li>';
      });
  }

  if (input) {
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      timer = setTimeout(function () { search(q); }, 180);
    });
    // Enter goes to the full results page, which is what the box implies.
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && input.value.trim())
        window.location.href = '/search?q=' + encodeURIComponent(input.value.trim());
    });
  }

  // ── cart ──────────────────────────────────────────────────────────
  var cartBody = bar.querySelector('#evCartBody');

  function renderCart (c) {
    if (!c.items || !c.items.length) {
      cartBody.innerHTML =
        '<h2 class="ev-cart-head">Your cart is empty.</h2>' +
        '<p class="ev-cart-empty">Sound kits, VST banks and bundles are a click away.</p>' +
        '<div class="ev-cart-foot"><a class="ev-btn2" href="/collections/all-kits">Browse the shop</a></div>';
      return;
    }

    var rows = c.items.map(function (i) {
      var img = i.image
        ? '<img src="' + esc(i.image) + '" alt="" loading="lazy">'
        : '<span class="ev-cart-thumb"></span>';
      return '<li>' + img +
             '<span><span class="ev-cart-t">' + esc(i.product_title || i.title) + '</span>' +
             '<span class="ev-cart-q">Qty ' + i.quantity + '</span></span>' +
             '<span class="ev-cart-p">' + moneyFromCents(i.line_price) + '</span></li>';
    }).join('');

    cartBody.innerHTML =
      '<h2 class="ev-cart-head">Your cart</h2>' +
      '<ul class="ev-cart-list">' + rows + '</ul>' +
      '<div class="ev-cart-foot">' +
        '<span class="ev-cart-sub">Subtotal <b>' + moneyFromCents(c.total_price) + '</b></span>' +
        '<span class="ev-cart-go">' +
          '<a class="ev-btn2" href="/cart">View cart</a>' +
          '<a class="ev-btn2 is-primary" href="/checkout">Checkout</a>' +
        '</span>' +
      '</div>';
  }

  function loadCart () {
    cartBody.innerHTML = '<h2 class="ev-cart-head">Your cart</h2>';
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { window.location.href = '/cart'; });   // fall back to the page
  }

  // ── wiring ──────────────────────────────────────────────────────
  var btnSearch = bar.querySelector('#evBtnSearch');
  var btnCart   = bar.querySelector('#evBtnCart');

  if (btnSearch) btnSearch.addEventListener('click', function (e) {
    e.preventDefault();
    show('search');
    if (open === 'search' && input) setTimeout(function () { input.focus(); }, 60);
  });

  if (btnCart) btnCart.addEventListener('click', function (e) {
    e.preventDefault();
    var wasOpen = open === 'cart';
    show('cart');
    if (!wasOpen) loadCart();
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // A click anywhere outside the bar closes whatever is open. Clicks INSIDE stay put,
  // or picking a search result would race the panel closing under the cursor.
  document.addEventListener('click', function (e) {
    if (open && !bar.contains(e.target)) close();
  });
})();
